import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import Translator from "../../Translation/Translator";

export default function* eventDelete(action: ActionInterface): any {
  try {
    yield call(Http.delete, `event/${action.payload?.event.id}`);

    // Automatically hide it on the first machine so it feels faster for end user.
    yield put({
      type: Constants.GLOBAL_EVENT_DELETE_SUCCESS
    });

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-message-event-removed-successfully", {eventname: Translator.trans(action.payload?.event?.entityTransKey)}),
        type: "success"
      }
    });

    yield put({
      type: Constants.GLOBAL_EVENTS_LIST_OUTDATE_REQUESTS
    })

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchEventDelete() {
  yield takeEvery(Constants.GLOBAL_EVENT_DELETE_START, eventDelete);
}
